import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-2xl mx-auto">
        <Link
          to="/sign-in"
          className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-gray-700 mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          Back
        </Link>

        <div className="bg-white rounded-xl shadow-sm p-8 space-y-6">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Privacy Policy</h1>
            <p className="text-sm text-gray-500 mt-1">Last updated: March 2026</p>
          </div>

          <section className="space-y-3">
            <h2 className="text-base font-semibold text-gray-900">What we collect</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              We collect the information needed to run your tennis program: player names and dates of
              birth, session attendance records, coach evaluations, and parent contact details.
              All data is entered by coaches and parents within your club.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-semibold text-gray-900">Who can see your data</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              Data is scoped to your club. Coaches can see their players' attendance and evaluations.
              Parents can see their own child's progress. Academy directors can see all data within
              their organisation. No data is visible to other clubs or third parties.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-semibold text-gray-900">Children's data</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              Player profiles for children are created by coaches on behalf of the club. Parents
              confirm parental consent when linking their account to their child's profile. We do
              not knowingly collect data from children directly.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-semibold text-gray-900">Data sharing</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              We do not sell or share your data with any third parties for marketing purposes.
              Data is stored securely on Convex infrastructure. Authentication is handled by Clerk.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-semibold text-gray-900">Your rights</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              You may request access to, correction of, or deletion of your personal data at any
              time. To make a request, contact your club administrator or email us at{' '}
              <a href="mailto:privacy@tenniscoach.app" className="text-blue-600 hover:underline">
                privacy@tenniscoach.app
              </a>
              .
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-base font-semibold text-gray-900">Changes to this policy</h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              We may update this policy from time to time. We will notify club administrators of
              any significant changes.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
